export const removeNonNumericCharacters = <T extends string | null | undefined>(value: T): T => {
  if (!value) {
    return value
  }
  return value.replace(/\D+/g, '') as T
}

export const matchEmail = (email1?: string | null, email2?: string | null) =>
  !!email1 && !!email2 && email1.toLowerCase() === email2.toLowerCase()
